import React from "react";
import { Edit, SimpleForm, TextInput } from "react-admin";
import Grid from "@material-ui/core/Grid";

const UserEdit = (props) => {
  return (
    <Edit title="Edit User" {...props}>
      <SimpleForm style={{ width: "100%" }}>
        <Grid container spacing={2} style={{ width: "100%" }}>
          <Grid item xs={12} sm={6}>
            <TextInput source="firstName" fullWidth />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput source="lastName" fullWidth />
          </Grid>
        </Grid>

        {/* <Grid container spacing={2} style={{ width: "100%" }}>
          <Grid item xs={12} sm={6}>
            <TextInput source="phoneNumber" fullWidth />
          </Grid>
        </Grid> */}
        <TextInput source="email" />
      </SimpleForm>
    </Edit>
  );
};

export default UserEdit;
